
import React from "react";
import { Page, PageType } from "../../../../types/page";
import CustomEditor from "../CustomEditor";
import DailyStudyEditor from "../DailyStudyEditor";
import SupabaseDataEditor from "../SupabaseDataEditor";
import VideoEditor from "../VideoEditor";
import PrayerTimesEditor from "../PrayerTimesEditor";
import TimesEditor from "../TimesEditor";
import PresetApiEditor from "../PresetApiEditor";
import ZmaneyHayomEditor from '../../ZmaneyHayomEditor';
import YahrzeitDisplayEditor from "../YahrzeitDisplayEditor";

interface ContentEditorSelectorProps {
  pageType: PageType;
  content: any;
  onContentChange: (field: string, value: any) => void;
}

const ContentEditorSelector: React.FC<ContentEditorSelectorProps> = ({
  pageType,
  content,
  onContentChange,
}) => {
  switch (pageType) {
    case "custom":
      return <CustomEditor />;
    case "daily-study":
      return <DailyStudyEditor content={content} onContentChange={onContentChange} />;
    case "supabase-data":
      return <SupabaseDataEditor content={content} onSave={(updatedContent) => onContentChange('', updatedContent)} />;
    case "video":
      return <VideoEditor content={content} onContentChange={onContentChange} />;
    case "preset-api":
      return <PresetApiEditor content={content} onContentChange={onContentChange} />;
    case "prayer-times":
      return <PrayerTimesEditor content={content} onContentChange={onContentChange} />;
    case "times":
      return <TimesEditor content={content} onContentChange={onContentChange} />;
    case "zmaney-hayom":
      return <ZmaneyHayomEditor content={content} onContentChange={onContentChange} />;
    case "yahrzeit_display":
      return <YahrzeitDisplayEditor content={content} onContentChange={onContentChange} />;
    default:
      return <CustomEditor />;
  }
};

export default ContentEditorSelector;
